import { useMemo } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import clsx from "clsx";

type Props = {
  state?: string
  states: any
  light?: boolean
  warning?: boolean
}

export const MarkerBadge = ({state, states, light, warning} : Props) => {

  const {title, path} = useMemo(() => {
    if (! ( state && states.hasOwnProperty(state))) {
      return {title: '', path: null};
    }
    return {title: states[state]?.state , path: states[state]?.icon }
  }, [state, states]);
  
  if (! path) {
    return null;
  }

  return (
    <div title={title} className="d-inline-block">
      <KTSVG path={path} className={clsx('me-2', 
        {'svg-icon-2x svg-icon-warning': light}, 
        {'svg-icon-3 svg-icon-warning': warning}, 
        {'svg-icon-3 svg-icon-danger' : (! (light || warning))}
      )}/>
    </div>   
  )
}